import React from 'react';
import { dismissals } from '../../data/dismissals';
import { Eyebrow } from '../ui/Eyebrow';
export function Dismissals() {
  return <section className="bg-cream" aria-labelledby="dismissals-heading" data-id="element-165" data-mp="3ihpluy8em88u">
      <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-28" data-id="element-166" data-mp="120t0b8s6vq6">
        <div className="grid gap-8 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20" data-id="element-167" data-mp="3s8bxkhd02em9">
          <div data-id="element-168" data-mp="3saekgsiuvrmr">
            <Eyebrow className="text-brick" data-id="element-169" data-mp="34ihhzs1aqbyb">What you’ve probably been told</Eyebrow>
            <h2 id="dismissals-heading" className="mt-5 max-w-md font-serif text-4xl leading-[1.05] text-ink md:text-[3.25rem]" data-id="element-170" data-mp="34katbkmutkcn">
              Four sentences. You have heard at least two of them.
            </h2>
            <p className="mt-6 max-w-md leading-relaxed text-ink-soft" data-id="element-171" data-mp="39gj6ishhr3h6">
              Women in this transition see multiple clinicians over several years before anyone
              names it. Not because the answers are unknown — because most clinicians were never
              taught them.
            </p>
          </div>

          <ul className="flex flex-col" data-id="element-172" data-mp="34sffx74mom1a">
            {dismissals.map(item => <li key={item.said} className="rule py-9 first:border-t-0 first:pt-0" data-id="element-173" data-mp="39qh0xxlm6vfe">
                <p className="font-serif text-3xl italic leading-snug text-ink-muted md:text-[2.5rem]" data-id="element-174" data-mp="3erwllojvqzx9">
                  “{item.said}”
                </p>
                <p className="mt-5 max-w-2xl leading-relaxed text-ink" data-id="element-175" data-mp="2m263z5j1hfwe">{item.truth}</p>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}